import Link from 'next/link';

import ChevronIcon from '@/fo/icons/base/icons/chevron16.svg';
import DiamondIcon from '@/fo/icons/base/icons/diamond.svg';
import GiftCardIcon from '@/fo/icons/base/icons/giftcard.svg';
import {
  GIFT_CARD_CLASS_NAME,
  MenuItem,
  STOCK_CLASS_NAME
} from '@/fo/ui/app/menu/base';

import { styles } from './Items.styles';

type NativeElement = React.HTMLAttributes<HTMLAnchorElement | HTMLDivElement>;

export interface ItemsProps {
  items?: MenuItem[];
  props?: (item: MenuItem, index: number) => NativeElement;
}

export function Items({ items = [], props }: ItemsProps) {
  const slots = styles();

  return (
    <>
      {items.map((item, index) => {
        const itemLabel = (
          <>
            {item.className && (
              <div className={slots.itemCircleWrapper()}>
                {item.className === GIFT_CARD_CLASS_NAME && <GiftCardIcon />}
                {item.className === STOCK_CLASS_NAME && (
                  <DiamondIcon className={slots.diamondIcon()} />
                )}
                {item.className !== STOCK_CLASS_NAME && (
                  <div
                    className={slots.itemCircle({
                      className: item.className
                    })}
                  />
                )}
              </div>
            )}
            <span>{item.label}</span>
          </>
        );

        const menuNode = (
          <>
            {item.children && item.href ? (
              <Link
                href={item.href}
                className={slots.itemLabel()}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                {itemLabel}
              </Link>
            ) : (
              <div className={slots.itemLabel()}>{itemLabel}</div>
            )}
            {item.children && <ChevronIcon />}
          </>
        );

        const elementProps = {
          ...props?.(item, index),
          className: slots.item(),
          onClick: (
            e: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>
          ) => {
            if (item.children && item.children.length > 0) {
              e.preventDefault();
              e.stopPropagation();
            }

            props?.(item, index)?.onClick?.(e);
          }
        };

        if (item.href && !item.children) {
          return (
            <Link
              key={index}
              href={item.href}
              {...elementProps}
            >
              {menuNode}
            </Link>
          );
        }

        return (
          <div
            key={index}
            {...elementProps}
          >
            {menuNode}
          </div>
        );
      })}
    </>
  );
}
